module.exports = __webpack_public_path__ + "static/media/maped.9f580cc8.png";